import { DragState } from '../hooks/useSheetHandlers';
import { getSnapPointSheetHeight } from './sheetHeightUtils';
import { isNumber, isString } from 'lodash';
import { MAX_SUFFIX } from '../hooks/useSheetContextState';

const VELOCITY_MULTIPLIER = 200;
const MAX_DEFAULT_REGEX = /(\d|.)+max$/;

/**
 * Initialise the snap points array.
 * Add 0 as a snap point to dismiss the sheet, and remove any invalid snap points
 */
export const initialiseSnapPoints = (snapPoints: number[], preventDismiss: boolean): number[] => {
    const points = snapPoints.filter((snapPoint) => snapPoint <= 1 && snapPoint > 0).sort();

    return preventDismiss ? points : [0, ...points];
};

export const getSnapPointTopValue = (snapPoint: number): number =>
    window.innerHeight - getSnapPointSheetHeight(snapPoint);

export const getNewActiveSnapPoint = (dragState: DragState, snapPointsState: number[]): number => {
    const { currentY, sheetTouchOffset, velocity } = dragState;

    // If user is dragging over a certain velocity, adjust the intended position to be further in that direction
    // Multiplier is just an arbitrary number based on what feels good. Velocity in px/ms
    const velocityAdjustment = VELOCITY_MULTIPLIER * velocity;
    const intendedSheetTop = currentY - sheetTouchOffset - velocityAdjustment;
    const snapDistances = snapPointsState.map((snapPoint: number) =>
        Math.abs(intendedSheetTop - getSnapPointTopValue(snapPoint)),
    );
    const smallestDistance = Math.min(...snapDistances);

    // go to the closest snap point
    const index = snapDistances.indexOf(smallestDistance);
    return snapPointsState[index];
};

export const getDefaultSnapPointDetails = (
    snapPoint: number | string | undefined,
): { point?: number; suffix?: string } => {
    if (!snapPoint) return {};

    // Check if it has the max suffix
    if (isString(snapPoint) && snapPoint.match(MAX_DEFAULT_REGEX)) {
        return { point: Number(snapPoint.split(MAX_SUFFIX)[0]), suffix: MAX_SUFFIX };
    }

    if (isNumber(snapPoint)) {
        return { point: snapPoint };
    }

    return {};
};
